import { useState, useEffect } from "react";
import { Collapse, Select, Spin } from "antd";
import { GetAllFaqApi } from "../../../api/request/faq.js";

const { Panel } = Collapse;

export default function Faq() {
  const [filter, setFilter] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const options = [
    { value: 1, label: "Account" },
    { value: 2, label: "Deposit" },
    { value: 3, label: "Client" },
    { value: 4, label: "Withdrawal" },
    { value: 5, label: "Platform" },
    { value: 6, label: "Internal Transfer" },
  ];

  const faqLabel = options.find((option) => option?.value === filter)?.label;

  const getFaq = async () => {
    setIsLoading(true);
    try {
      const params = {
        ApplyPagination: true,
        SortBy: "CreateDate",
        fAQFilters: filter,
      };

      const { data } = await GetAllFaqApi(params);
      if (data?.success) setData(data?.data);
    } catch (error) {
      console.error("Failed to fetch FAQs:", error);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getFaq();
  }, [filter]);

  const customExpandIcon = ({ isActive }) => (
    <span>
      {isActive ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-6 h-6 mt-2"
        >
          <path
            fill-rule="evenodd"
            d="M4.25 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z"
            clip-rule="evenodd"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-6 h-6 mt-2"
        >
          <path
            fill-rule="evenodd"
            d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z"
            clip-rule="evenodd"
          />
        </svg>
      )}
    </span>
  );

  return (
    <div>
      <Select
        className="min-w-44 ant-select-selector-white"
        value={filter}
        onChange={setFilter}
        options={options}
      />

      <div className="border-[2px] border-light rounded-xl p-4 lg:p-6 w-full mt-5">
        <p className="primary text-xl font-semibold mb-6">{faqLabel} FAQs</p>
        <div>
          {isLoading ? (
            <div className="flex justify-center flex-col my-[10%]">
              <Spin size="large" />
              <p className="primary text-center mt-2">Loading...</p>
            </div>
          ) : (
            <div>
              {data?.length > 0 ? (
                <Collapse bordered={false} expandIcon={customExpandIcon}>
                  {data?.map((faq) => (
                    <Panel
                      header={faq?.question}
                      key={faq?.questionId}
                      className="custom-panel"
                    >
                      <p dangerouslySetInnerHTML={{ __html: faq?.answer }}></p>
                    </Panel>
                  ))}
                </Collapse>
              ) : (
                <p className="text-center primary my-[12%]">No Record Found</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
